// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { billingSummarySchema } from '@/billing/api/types';
import { z } from 'zod';

const billingSummaryResponseSchema = z.object({
  data: billingSummarySchema,
  metadata: responseMetadataSchema,
});

export async function getBillingSummary() {
  const url = '/v1/billing/summary';
  const response = await api.get(url);

  const result = await parseResponse(
    billingSummaryResponseSchema,
    response.data,
    {
      schemaName: 'BillingSummary',
      endpoint: url,
    }
  );

  return result.data;
}
